import { render, staticRenderFns } from "./AuthManagementSearch.vue?vue&type=template&id=2f87078c&scoped=true&"
import script from "./AuthManagementSearch.vue?vue&type=script&lang=js&"
export * from "./AuthManagementSearch.vue?vue&type=script&lang=js&"
import style0 from "./AuthManagementSearch.vue?vue&type=style&index=0&id=2f87078c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f87078c",
  null
  
)

export default component.exports